import {Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ApiResponse, Catalog, CatalogWithAncestors, DamElasticDTO, FileService, ListTable, NgxEasyTablePagination} from 'compob2b-libs';
import {BehaviorSubject, Observable} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {translations} from '../../../../../../environments/translations.ru';
import {
  DamChooseCatalogModalComponent
} from '../../../../../admin-shared/custom-form-types/dam-choose-catalog-modal/dam-choose-catalog-modal.component';
import {DamService} from '../../../dam.service'

interface ContextType {
  catalogChosenEvent: EventEmitter<CatalogWithAncestors>;
  removeCatalogEvent: EventEmitter<CatalogWithAncestors>;
  chosenCatalogs?: Catalog[];
  onlyOneSelection?: boolean;
  chooseOnlyLastLevel?: boolean;
}

@Component({
  selector: 'app-plates-view',
  templateUrl: './plates-view.component.html',
  styleUrls: ['./plates-view.component.scss'],
})

export class PlatesViewComponent extends ListTable implements OnInit {
  @Input() isShowProductList: boolean;
  @Input() selected$ = new BehaviorSubject(new Set());
  @Input() pagination: NgxEasyTablePagination;
  @Input() damElements: DamElasticDTO[];
  @Input() write: boolean = true;
  @Input() share: boolean = false;

  @Output() elementClickEventEmitter = new EventEmitter<DamElasticDTO>();
  @Output() elementSelectEvent = new EventEmitter<DamElasticDTO>();
  // @Output() allElementSelectEvent = new EventEmitter<DamElasticDTO[]>();
  @Output() elementShareEvent = new EventEmitter<DamElasticDTO>();

  @ViewChild('statusTpl', {static: true}) statusTpl: TemplateRef<any>;
  @ViewChild('headerTpl', {static: true}) headerTpl: TemplateRef<any>;
  @ViewChild('imageTpl', {static: true}) imageTpl: TemplateRef<any>;
  @ViewChild('tagsTpl', {static: true}) tagsTpl: TemplateRef<any>;
  @ViewChild('countVersionTpl', {static: true}) countVersionTpl: TemplateRef<any>;
  @ViewChild('ownerTpl', {static: true}) ownerTpl: TemplateRef<any>;
  @ViewChild('actionsTpl', {static: true}) actionsTpl: TemplateRef<any>;

  catalogChosenEvent = new EventEmitter<CatalogWithAncestors>();
  removeCatalogEvent = new EventEmitter<CatalogWithAncestors>();
  damItemChangeCatalogId = 0;
  protected readonly translations = translations

  fileService = inject(FileService);
  damService = inject(DamService);

  markSelectedElements() {
    this.damElements?.forEach(item => {
      item.selected = this.selected$.value.has(item.id);
    });
  }

  ngOnInit() {
    if (this.write) {
      this.configuration.checkboxes = true;
    }
    this.setTableColumns();
    this.tableService.initFrom(this);
    this.markSelectedElements();
    this.cdr.detectChanges();

    this.catalogChosenEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.compoApiService.post('/dam/items/change-catalog/', {
          damCatalogId: response?.id, damItemId: this.damItemChangeCatalogId
        }).subscribe();
      });
  }

  setTableColumns() {
    this.columns = [{
      title: translations.name, key: 'image', cellTemplate: this.imageTpl
    }, {
      title: translations.name, key: 'header', cellTemplate: this.headerTpl
    }, {
      title: translations.countVersion, key: 'countVersion', cellTemplate: this.countVersionTpl
    }, {
      title: translations.status, key: 'status', cellTemplate: this.statusTpl
    }];

    if (this.write) {
      this.columns.push({
        title: translations.owner, key: 'managerName', cellTemplate: this.ownerTpl
      });
      this.columns.push({
        title: translations.tags, key: 'tags', cellTemplate: this.tagsTpl
      });
      this.columns.push({
        title: '', key: 'actions', cellTemplate: this.actionsTpl
      });
    }
  }

  elementClickEvent(damElement: DamElasticDTO) {
    this.elementClickEventEmitter.emit(damElement);
  }

  elementSelectHandler(damElement: DamElasticDTO, $event) {
    damElement.selected = $event;
    if ($event) {
      this.selected$.value.add(damElement.id);
    }
    else {
      this.selected$.value.delete(damElement.id);
    }
    this.elementSelectEvent.emit(damElement);
  }

  elementShareHandler(damElement: DamElasticDTO) {
    this.elementShareEvent.emit(damElement);
  }

  elementChangeCatalogHandler(damElement: DamElasticDTO) {
    this.damItemChangeCatalogId = damElement?.id;
    const data: ContextType = {
      catalogChosenEvent: this.catalogChosenEvent, removeCatalogEvent: this.removeCatalogEvent, chosenCatalogs: null,
    };
    data.onlyOneSelection = true;
    data.chooseOnlyLastLevel = true;

    this.windowService.open(DamChooseCatalogModalComponent, {
      context: data, title: translations.catalog
    });
  }

  onElementDelete(selectedItem: DamElasticDTO) {
    this.confirm(
      translations.confirmDelete + ' ' + translations.file.toLowerCase() + '?', new Observable(() => {
        this.compoApiService
          .delete<ApiResponse<string>>('/dam/item/' + selectedItem?.id)
          .pipe(take(1))
          .subscribe(
            _ => window.location.reload(),
            _ => this.errorToast('У вас недостаточно прав для данной операции')
          );
      }));
  }

}
